import React from 'react';
import Flexbox from 'flexbox-react';
import BadgedItemList from 'components/page/process/variableRetrieval/BadgedItemList';
import ListItem from 'components/core/ListItem';
import RollupError from 'components/core/RollupError';
import ProcessUtils from 'utils/ProcessUtils';
import { Tooltip } from 'antd';

export default class CoordinateSystemsList extends BadgedItemList {

    renderItem = (name, value, selected) => {
        const dimensions = Object.keys(value.dimensions);
        const dimsList = ProcessUtils.getDimensionsAsString(dimensions);
        let dimsListComponent = dimsList.visibleList;
        if (dimsList.tooltip) {
            console.log('ye');
            dimsListComponent = <Tooltip placement={'top'} title={dimsList.fullList}>{dimsList.visibleList}</Tooltip>
        }

        let badge = <span />;
        if (!this.props.hideBadges) {
            badge = <span className="badged-item circle" style={this.props.getBackgroundColor(this.props.type, name)} />;
        }

        return (
            <ListItem
                key={name}
                name={name}
                className={this.getItemClassName()}
                selected={selected}
                onClick={this.onClick}
                onDoubleClick={this.props.onDoubleClick}
            >
                <Flexbox flexDirection="row" alignItems="center" title={'Double click to edit'}>
                    {badge}
                    <span style={{ whiteSpace: 'nowrap', flexGrow: 1 }}>
                        <span className={`badged-item-label`}>
                            <RollupError
                                fieldPath={[...this.props.baseFieldPath, name]}
                                processErrors={this.props.processErrors}
                                process={this.props.process}
                                includeChildren
                            />
                            {this.renderEntity(name, dimsListComponent)}
                        </span>
                    </span>
                </Flexbox>
            </ListItem>
        );
    };

    renderItems(filteredIds, selectedItems) {
        const invisibleStyle = { backgroundColor: 'white', border: '1px solid #e8e8e8', width: '15px', height: '15px', marginTop: '-1px' };
        const items = super.renderItems(filteredIds, selectedItems);
        if (!this.props.hideBadges) {
            items.push(
                <Flexbox key="undefined" flexDirection="row" alignItems="center" padding="4px 7px">
                    <span className="badged-item circle" style={invisibleStyle} />
                    <span className="legend badged-item-label">No Transformation</span>
                </Flexbox>
            );
        }

        return items;
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/CoordinateSystemsList.js